module.exports = __webpack_public_path__ + "img/khd_ewm.ecb6eb2b.png";